var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsdocImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M77.3 52.5h102.4v85.9H46.3v-22.6M77.3 70.1h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    strokeDasharray: "11.5,11.5",
    d: "M95 70.1h64.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M165 70.1h6v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    strokeDasharray: "14.25,14.25",
    d: "M171 90.3v21.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M171 118.9v6h-6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    strokeDasharray: "11.5,11.5",
    d: "M153.5 124.9H67.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M61.5 124.9h-6v-5.3M105 139.8v8.5c-.1 9.9-10.5 9.6-10.5 9.6H70.2v6.4h85.9l-.1-6.4h-24.3s-10.5.4-10.5-9.6v-8.5M77.3 108.7v4.1c0 1.7-1.4 3-3 3H14.4c-1.7 0-3-1.4-3-3V34.7c0-1.7 1.4-3 3-3h47.3L77.3 46v41M77.3 46H61.7M61.7 46V31.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M64.6 93.9v7.9h20.1v9.5l13.4-14.1-13.7-12.9v9.6zM34.6 69.9s1.4-7.8 6.6-14c5.4-5.4 14.1-6.6 14.1-6.6s-.7 10.7-5.8 14.3c-5.9 4.6-14.9 6.3-14.9 6.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M43.8 52.9s-2.1-1.3-4.9-2.3-4.5-1.3-4.5-1.3.7 6.9 3.5 11.2M45.5 66.2s2.2 1.4 4.2 2.1 5.1 1.3 5.1 1.3.2-6.1-2.5-9.2M44.2 58.1l2.5.3.2 2.5M48 55.4l1.7.3.2 1.6M41.7 61.2l1.7.2.2 1.7M37.9 77.5v9.1s7.1 1 7.1-4.8c0 0-.2-5.6-7.1-4.3zM20.2 77.3v9.3M31.9 78.3s-2.4-2.2-4.9-.7c-2.2 1.7-.2 3.8 2.7 4.1 4.1.7 3.8 4.9-.3 5.1-3.2.3-4.3-1.8-4.3-1.8M54.5 77s-4.5-.8-4.8 4.7c0 4.4 2 5.2 4.5 5.2 2.4 0 4.1-1.6 4.1-5.1 0-3-1.5-4.5-3.8-4.8zM70.4 77.7s-6.4-3.3-7.2 3.9c-.6 7.8 7.2 4.8 7.2 4.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsdocImport);
export default __webpack_public_path__ + "static/media/isdocImport.ea5505be317c143ba247b0439ab4370c.svg";
export { ForwardRef as ReactComponent };